module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "cont",
      "epub:type": "toc",
      "role": "doc-toc"
    }
  }, [_c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('header', [_c('h1', {
    staticClass: "FMH",
    attrs: {
      "id": "cont"
    }
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    staticClass: "CFMH"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/abbreviations",
      "id": "c_abb"
    }
  }, [_c('i', [_vm._v("List of Abbreviations")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCTF"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction",
      "id": "c_int"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    staticClass: "CH1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#h-1",
      "id": "h_1"
    }
  }, [_vm._v("Introducing Neoliberalism")]), _vm._v(" • "), _c('a', {
    attrs: {
      "href": "#/xhtml/introduction#h-2",
      "id": "h_2"
    }
  }, [_vm._v("Catholic Critique of Neoliberalism")]), _vm._v(" • "), _c('a', {
    attrs: {
      "href": "#/xhtml/introduction#h-3",
      "id": "h_3"
    }
  }, [_vm._v("Chapter Outlines")]), _vm._v(" • "), _c('a', {
    attrs: {
      "href": "#/xhtml/introduction#h-4",
      "id": "h_4"
    }
  }, [_vm._v("Send Lazarus")])]), _vm._v(" "), _c('li', {
    staticClass: "CPT"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part1",
      "id": "c_pt1"
    }
  }, [_c('samp', {
    staticClass: "SANS_ScalaSans_Caps_SC_11"
  }, [_vm._v("PART I: CATHOLIC SOCIAL THOUGH")]), _c('samp', {
    staticClass: "SANS_ScalaSans_Caps_SC_11"
  }, [_vm._v("T AND THE ECONOMY")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1",
      "id": "c_ch1"
    }
  }, [_vm._v("1   Catholic Social Thought against Economism")])]), _vm._v(" "), _c('li', {
    staticClass: "CH1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#h-5",
      "id": "h_5"
    }
  }, [_vm._v("Modern Catholic Social Thought")]), _vm._v(" • "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#h-6",
      "id": "h_6"
    }
  }, [_vm._v("John Paul II on Economism")]), _vm._v(" • "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#h-7",
      "id": "h_7"
    }
  }, [_vm._v("Benedict XVI: Against an Impersonal Economy")]), _vm._v(" • "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#h-8",
      "id": "h_8"
    }
  }, [_vm._v("Francis: No to a Faceless Economy")]), _vm._v(" • "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#h-9",
      "id": "h_9"
    }
  }, [_vm._v("Papal Continuity")])]), _vm._v(" "), _c('li', {
    staticClass: "CPT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2",
      "id": "c_pt2",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_ScalaSans_Caps_SC_11"
  }, [_vm._v("PART II: NEOLIBERALISM")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2",
      "id": "c_ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2   Neoliberal Capitalism")])]), _vm._v(" "), _c('li', {
    staticClass: "CH1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2#h-10",
      "id": "h_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Neoliberalism as Political Economy")]), _vm._v(" • "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter2#h-11",
      "id": "h_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Neoliberalism as Common Sense")]), _vm._v(" • "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter2#h-12",
      "id": "h_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ethos of Mercilessness")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3",
      "id": "c_ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3   Sacrifice, Race, and Indifference")])]), _vm._v(" "), _c('li', {
    staticClass: "CH1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#h-13",
      "id": "h_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sacrifice Zones, Earth, and Slums")]), _vm._v(" • "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#h-14",
      "id": "h_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Racial Neoliberalism, Mass Incarceration, and Mass Deportation")]), _vm._v(" • "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#h-15",
      "id": "h_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Neoliberalism as Culture of Indifference")])]), _vm._v(" "), _c('li', {
    staticClass: "CPT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part3",
      "id": "c_pt3",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "SANS_ScalaSans_Caps_SC_11"
  }, [_vm._v("PART III: CATHOLIC MERCY IN")]), _vm._v(" "), _c('samp', {
    staticClass: "SANS_ScalaSans_Caps_SC_11"
  }, [_vm._v("A NEOLIBERAL AGE")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4",
      "id": "c_ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4   A Theology of Mercy")])]), _vm._v(" "), _c('li', {
    staticClass: "CH1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#h-16",
      "id": "h_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trinity, Mystery, and Mercy")]), _vm._v(" • "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#h-17",
      "id": "h_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Anthropology, Ecclesiology, and Mercy")]), _vm._v(" • "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#h-18",
      "id": "h_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Works and the Politics of Mercy")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5",
      "id": "c_ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5   The Politics of Mercy against Neoliberal Sacrifice")])]), _vm._v(" "), _c('li', {
    staticClass: "CH1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#h-19",
      "id": "h_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Universal Destination of Goods")]), _vm._v(" • "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#h-20",
      "id": "h_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Visit the Sick")]), _vm._v(" • "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#h-21",
      "id": "h_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Give Food, Drink, and Clothing")]), _vm._v(" • "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#h-22",
      "id": "h_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Abolitionism")]), _vm._v(" • "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#h-23",
      "id": "h_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ransom the Captive")]), _vm._v(" • "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#h-24",
      "id": "h_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Welcome the Stranger")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/conclusion",
      "id": "c_con",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: For Holistic Mercy")])]), _vm._v(" "), _c('li', {
    staticClass: "CBMHF"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/acknowledgments",
      "id": "c_ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('li', {
    staticClass: "CBMH"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes",
      "id": "c_not",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Notes")])])]), _vm._v(" "), _c('li', {
    staticClass: "CBMH"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bibliography",
      "id": "c_bib",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('li', {
    staticClass: "CBMH"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index",
      "id": "c_ind",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Index")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ac427ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 72
// module chunks = 0